import { render, staticRenderFns } from "./RestaurantOrderCreate.vue?vue&type=template&id=8823bdc4&"
import script from "./RestaurantOrderCreate.vue?vue&type=script&lang=js&"
export * from "./RestaurantOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports